import { relatorios } from "./utils/relatorio";

export const routes = [
  {
    path: "/dashboard-administrativo2/radar-sc-hlg",
    component: () => import("./newAdmin/components/RadarScHlg.vue"),
    name: "administrative.radar-sc-hlg",
    meta: { requiresAuth: true },
  },
  {
    path: "/dashboard-administrativo2", 
    component: () =>
      import(
        /* webpackChunkName: "administrative-dashboard" */ "./newAdmin/resumo"
      ),
    name: "administrative.dashboard",
    redirect: (to) => {
      return "dashboard-administrativo2/graficos";
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/dashboard-administrativo2/consulta-avancada",
    component: () =>
      import(
        /* webpackChunkName: "administrative-dashboard" */ "./newAdmin/consultaAvancada.vue"
      ),
    name: "administrative.consulta-avancada",
    meta: {
      requiresAuth: true,
      requiresFullAdmin: true,
    },
  },
  {
    path: "/dashboard-administrativo2/graficos",
    component: () =>
      import(
        /* webpackChunkName: "administrative-dashboard" */ "./newAdmin/resumo"
      ),
    name: "administrative.graficos",
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/dashboard-administrativo2/relatorio/:relatorioRoute",
    component: () =>
      import(
        /* webpackChunkName: "administrative-dashboard" */ "./newAdmin/resumo"
      ),
    name: "administrative.resumo",
    meta: {
      requiresAuth: true,
      verifyVisibleRelatorio: true,
    },
  },
];
